import { render, staticRenderFns } from "./kb_search.vue?vue&type=template&id=0d32c7c2"
import script from "./kb_search.vue?vue&type=script&lang=js"
export * from "./kb_search.vue?vue&type=script&lang=js"
import style0 from "./kb_search.vue?vue&type=style&index=0&id=0d32c7c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports